import React from 'react';
import { Button } from '../base/Button';

export const HeroSection: React.FC = () => {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/68b23d34471bcaa5a1e5c9ca06c2d3b5.jpg"
          alt="Modern Apartment Building"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="text-white">
              <h1 className="text-5xl lg:text-7xl font-black leading-tight mb-6">
                Sell Your <br />
                Multifamily <br />
                <span className="text-orange-500">Property</span>
              </h1>
              
              <h2 className="text-2xl lg:text-3xl font-light mb-8 text-gray-200">
                Quick Closings on Apartments &amp; Commercial Buildings
              </h2>
              
              <div className="space-y-4">
                <Button 
                  size="lg" 
                  className="w-full sm:w-auto"
                  icon="ri-arrow-right-line"
                  href="#get-offer"
                >
                  GET CASH OFFER NOW
                </Button>
                
                <Button 
                  variant="ghost" 
                  size="lg" 
                  className="w-full sm:w-auto ml-0 sm:ml-6"
                  href="#how-it-works"
                >
                  See How It Works
                </Button>
              </div>
            </div>

            {/* Right Stats Card - Removed */}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
};
